/**
 * Maps education levels to their valid year options
 * Based on the Dutch education system structure
 */

export const YEARS_BY_LEVEL = {
  'MBO Niveau 1': ['Jaar 1'],
  'MBO Niveau 2': ['Jaar 1', 'Jaar 2'],
  'MBO Niveau 3': ['Jaar 1', 'Jaar 2', 'Jaar 3'],
  'MBO Niveau 4': ['Jaar 1', 'Jaar 2', 'Jaar 3', 'Jaar 4'],
  'HBO Associate Degree': ['Jaar 1', 'Jaar 2'],
  'HBO Bachelor': ['Jaar 1', 'Jaar 2', 'Jaar 3', 'Jaar 4'],
  'HBO Master': ['Jaar 1', 'Jaar 2'],
  'Universiteit Bachelor': ['Jaar 1', 'Jaar 2', 'Jaar 3'],
  'Universiteit Master': ['Jaar 1', 'Jaar 2']
}

/**
 * Get valid years for a given education level
 * @param {string} level - The education level (e.g., "HBO Bachelor")
 * @returns {string[]} Array of valid year strings (e.g., ["Jaar 1", "Jaar 2", ...])
 */
export const getYearsForLevel = (level) => {
  return YEARS_BY_LEVEL[level] || []
}
